<template>
    <table class="table table-bordered mb-0" v-if="participant">
        <tbody>
            <tr v-for="(value, key, index) in participant" :key="index">
                <th class="text-right" width="50%">{{ getLabel(key) }}</th>
                <td>
                    <fa-icon v-if="value === 'x'" icon="check"></fa-icon>
                    <span v-else>{{ value }}</span>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import { get } from "lodash-es";
import { FIELDS } from "@/shared/constants.js";

export default {
    name: "ParticipantDetail",
    props: {
        participant: {
            type: Object,
            default: null
        }
    },
    methods: {
        getLabel(key) {
            const short = get(FIELDS[key], "short");
            const long = get(FIELDS[key], "long");

            return long ? long : short ? short : key;
        }
    }
};
</script>
